import React, { useEffect, useRef } from 'react';
import {IProps} from './types';
import * as S from './styles';
import { ArrowDownIcon } from '@assets/icons/arrowDownIcon';
import { ArrowLeftIcon } from '@assets/icons/arrowLeftIcon';
import NotHiddenIcon from '@assets/icons/notHiddenIcon';
import HiddenIcon from '@assets/icons/hiddenIcon';
import { ColSize } from '@routes/private/Templates/components/ListTemplate/components/ItemTemplate/styles';
import ClickOutside from '@components/ClickOutside';

const LayerGroup:React.FC<IProps> = (props) => {  
  const [isEditing, setIsEditing] = React.useState<boolean>(false);
  const [title, setTitle] = React.useState<string>();
  const editInput = useRef<HTMLInputElement>(null);


  const handleEdit=()=>{
    if (props.title.toUpperCase()!=="SET")
      setIsEditing(true)
  }

  const handleKeyDown=(e:any)=>{    
        
    if (e.key=="Escape")
    {
      setTitle(props.title)
      setIsEditing(false);
    }
    if (e.key=="Enter")
    {    
      if (!isReservedWord())  
      {
        if (props.onEdit && editInput.current)
        {        
          props.onEdit(editInput.current.value)               
        }
        setIsEditing(false);
      }
    }    

  }

  const isReservedWord = ()=>
  {
    let text = editInput.current!.value??''
    return text.toUpperCase()=="SET";          
  }

  const endEditing=()=>{    
    if (isEditing && props.onEdit && editInput.current)
    {    
      if (!isReservedWord())        
        props.onEdit(editInput.current.value)           
      else
        setTitle(props.title)
      setIsEditing(false);
    }
  }

  useEffect(()=>{
    setTitle(props.title)
  },[props.title])
  return (
    <S.Root>      
      <S.TitleRow level={props.level}>
        <S.IconContainer onClick={props.onClick} onDoubleClick={handleEdit}>
          <S.ArrowDown style={!props.isOpen?{transform: 'rotate(-90deg)'}:{}}/>
        </S.IconContainer>
        <S.Title onClick={props.onClick} onDoubleClick={handleEdit}>
         {
            isEditing?
            <ClickOutside onClickOutside={()=> endEditing()} event={"mousedown"}>
              <S.EditContainer value={title} onKeyDown={handleKeyDown} ref={editInput}
              onChange={event => setTitle(event.target.value)}>          
              </S.EditContainer>
            </ClickOutside>
              :
              title
            
          }
        </S.Title>
        {props.hidden ? 
        <S.VisibilityIconContainer onClick={() => props.HideUnhide(props.id)}>
          <HiddenIcon style={{overflow: 'inherit', marginLeft: 'auto', marginRight: '18px'}}/> 
        </S.VisibilityIconContainer>
        : 
        <S.VisibilityIconContainer onClick={() => props.HideUnhide(props.id)}>
          <NotHiddenIcon style={{overflow: 'inherit', marginLeft: 'auto', marginRight: '18px'}}/>
        </S.VisibilityIconContainer>
        }
      </S.TitleRow>      
      <S.GroupContent>
          {props.isOpen && props.children}
      </S.GroupContent>
      
    </S.Root>
  );
}

export default LayerGroup;